import { cn } from '@/lib/cn';
import { methodBadgeClass } from '@/lib/methodColor';
import type { HttpMethod } from '@/api/client';

interface Props {
  method: HttpMethod | string;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * HTTP method pill — neo-brutalism style.
 *
 * Solid pastel bg per method, thick black border, bold mono. Uniform
 * min-width so endpoint lists align. `sm` skip offset shadow (too noisy
 * di list 313 endpoint); `md` keeps it for hero/inline use.
 */
export function MethodBadge({ method, size = 'sm', className }: Props) {
  const isMd = size === 'md';
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center font-mono font-bold uppercase tracking-wider',
        'border-2 border-border-strong rounded-pill',
        isMd ? 'h-7 px-3 text-2xs shadow-brutal-sm' : 'h-5 px-2 text-[10px]',
        methodBadgeClass(method),
        className
      )}
      style={{ minWidth: isMd ? '4.5rem' : '3.5rem' }}
    >
      {method.toUpperCase()}
    </span>
  );
}
